import { createContext } from "react";

export const Theme = {
  Light: "light",
  Dark: "dark",
} as const;

export type Theme = (typeof Theme)[keyof typeof Theme];

export const THEME_STORAGE_KEY = "app.theme";

export function getInitialTheme(): Theme {
  // Dark mode is disabled in the UI, so ignore stale per-origin preferences
  // and OS color-scheme settings. This keeps fresh workspace ports light too.
  return Theme.Light;
}

export function applyTheme(theme: Theme) {
  const root = document.documentElement;
  const body = document.body;
  const mode = theme === Theme.Dark ? "dark" : "light";

  if (theme === Theme.Dark) {
    root.classList.add("dark");
  } else {
    root.classList.remove("dark");
  }

  // data-mode drives AppKit's [data-mode=light/dark] token overrides.
  // data-theme stays as "momentum-orange" (set in index.html).
  root.setAttribute("data-mode", mode);
  body.setAttribute("data-mode", mode);
}

export interface ThemeContextValue {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  toggleTheme: () => void;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);
